import { Dispatch, SetStateAction } from 'react'

import { AvailableModules, Features } from 'generated/featureDefinitions'
import { ItemIntegrationFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { useGetMarketplaceIntegrationUpsells } from 'modules/marketplace/hooks/integrations/useGetMarketplaceIntegrationUpsells'
import { usePayrollModuleAvailability } from 'modules/marketplace/hooks/usePayrollModuleAvailability'
import { locale } from 'modules/marketplace_modules/components/utils/locales'
import RequestUpgradeModal from 'modules/upsell/components/RequestUpgradeModal'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

import { CompensationsUpsellModal } from './CompensationsUpsellModal'

interface UpsellModalInterface {
  integration: ItemIntegrationFragment
  upsellModalVisible: boolean
  setUpsellModalVisible: Dispatch<SetStateAction<boolean>>
  featureId?: Features
}

export const UpsellModal = ({
  integration,
  upsellModalVisible,
  setUpsellModalVisible,
  featureId,
}: UpsellModalInterface) => {
  const { access } = useCurrentSession()
  const datoFormatLocale = locale[access.locale]

  const { shouldShowPayrollUpsell } = usePayrollModuleAvailability(integration)

  const { loading: _loadingUpsells, data } = useGetMarketplaceIntegrationUpsells({
    integrationDatoId: integration.datoId,
    locale: datoFormatLocale,
  })
  const modalData = data?.[0]

  if (!upsellModalVisible) {
    return null
  }

  // Show compensations upsell modal for payroll integrations when neither module is available
  if (shouldShowPayrollUpsell) {
    return (
      <CompensationsUpsellModal
        integration={integration}
        onClose={() => setUpsellModalVisible(false)}
        featureId={featureId}
      />
    )
  }

  return (
    <RequestUpgradeModal
      title={modalData?.title || undefined}
      description={modalData?.description || undefined}
      customSuccessDescription={modalData?.successDescription || undefined}
      requestReason={ValidReasons.MissingAddon}
      requestSource={`integration-${integration.slug}`}
      moduleRequested={AvailableModules.marketplace}
      featureRequested={featureId}
      onClose={() => setUpsellModalVisible(false)}
    />
  )
}
